import { BoxPlotFilled } from '@ant-design/icons'
import { GraviButton } from '@gravitate-js/excalibrr'
import { Row } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

export function ProductInfo({ tank }) {
  return (
    <div className='store-expand-card p-4'>
      <Row className='store-detail-header'>
        <b>Product Info</b>
      </Row>
      <Row className='text-size-8 pt-2 pb-2'>
        <b style={{ whiteSpace: 'initial' }}>{tank.product}</b>
      </Row>
      <Row className='tank-transition-strategy-row pt-3'>
        <div className='flex justify-sa items-center full-height-width'>
          <BoxPlotFilled className='admin-store-tank text-size-8' />
          <div className='flex-1 pl-4'>
            <Row className='text-gray-500'>Tank Transitions</Row>
            <Row>{tank.tank_transition.length > 0 ? 'Scheduled' : 'Not Scheduled'}</Row>
          </div>
          <Link
            target='_blank'
            to={`/admin/transition?${new URLSearchParams({
              store_number: tank.store_number,
              tank_id: tank.tank_id,
            })}`}
          >
            <GraviButton ghost buttonText='View' style={{ color: 'var(--theme-color-2)' }} />
          </Link>
        </div>
      </Row>
      <Row className='pt-3'>
        <div className='flex justify-sa items-center full-height-width'>
          <BoxPlotFilled className='admin-store-tank text-size-8' />
          <div className='flex-1 pl-4'>
            <Row className='text-gray-500'>Tank Strategy</Row>
            <Row>{tank.inventory_strategy}</Row>
          </div>
          <Link
            target='_blank'
            to={`/admin/strategy?${new URLSearchParams({
              store_number: tank.store_number,
              tank_id: tank.tank_id,
            })}`}
          >
            <GraviButton ghost buttonText='View' style={{ color: 'var(--theme-color-2)' }} />
          </Link>
        </div>
      </Row>
    </div>
  )
}
